var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivilegeSuccessPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 78,
    viewBox: "0 0 390 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.813 126.31C386.378 126.755 388.012 127.348 389.537 127.901C472.006 157.834 514.539 248.88 484.595 331.382C454.651 413.884 363.621 456.454 281.152 426.521C198.684 396.589 156.151 305.543 186.095 223.041C193.413 202.878 204.445 185.051 218.004 170.114",
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.281 207.097C226.621 196.307 220.763 183.573 218.004 170.114C214.957 155.07 215.93 139.142 221.547 123.666C222.496 121.05 223.554 118.474 224.682 116.047C243.556 76.2738 289.909 56.588 332.178 71.9298C339.913 74.7372 346.925 78.5158 353.185 83.0082C368.222 93.8928 379.112 109.069 384.705 126.271C389.048 139.441 390.243 153.813 387.665 168.048",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.803 174.211C153.973 161.058 147.903 139.737 155.102 119.901C159.414 108.022 167.836 98.7446 178.141 93.1109C183.349 90.3139 188.972 88.408 194.863 87.4627C202.775 86.3871 211.043 87.0447 218.996 89.9312C220.63 90.5243 222.333 91.2659 223.928 91.968",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.415 218.492C111.509 194.489 94.5342 147.502 110.238 104.235C121.868 72.1929 148.672 49.9759 179.583 42.9404C180.887 36.6299 182.667 30.3685 184.961 24.0474C211.503 -49.0819 292.286 -86.8598 365.386 -60.328C438.377 -33.8357 476.093 46.705 449.847 119.695",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.808 108.417C220.133 87.1371 218.983 62.7911 227.448 39.4682C245.486 -10.2291 300.282 -35.8542 349.959 -17.8237C397.131 -0.702541 422.633 49.6266 409.565 97.1808",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.631 85.0156C247.377 73.2202 248.114 60.66 252.505 48.5626C265.519 12.7064 305.019 -5.76589 340.861 7.243C374.306 19.382 392.652 54.7794 384.31 88.6314",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.023 69.5208C281.298 66.0439 281.94 62.5766 283.206 59.0891C290.208 39.7986 311.443 29.868 330.726 36.8668C349.572 43.7073 359.405 64.174 353.403 83.0873L353.294 83.0477C369.386 84.5712 385.459 88.1848 401.255 93.9182C502.68 130.731 554.996 242.719 518.169 344.185C481.342 445.65 369.374 498.012 267.95 461.199C166.525 424.387 114.209 312.398 151.036 210.933C165.593 170.826 191.937 138.328 224.682 116.047",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.821 109.801C455.081 46.8492 422.094 -21.2443 359.453 -43.9802C295.395 -67.2301 224.561 -34.105 201.302 29.9784C200.036 33.466 198.879 36.9931 197.98 40.4902C196.349 46.6821 195.154 53.0322 194.474 59.3224C188.374 59.8222 182.473 61.134 176.741 63.0003C154.772 70.1977 136.174 87.1293 127.629 110.67C115.446 144.238 127.603 180.719 155.121 200.698",
    stroke: "white",
    strokeWidth: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivilegeSuccessPattern);
export default __webpack_public_path__ + "static/media/privilege-success-pattern.c5fb37a7.svg";
export { ForwardRef as ReactComponent };